import { CELLS, getDefaultColumnParams } from "@/helpers/table.helpers"
import { NumberConvertor } from "@/hooks/useNumberConvertor"
import { ImpactCell } from "@/molecules/ImpactCell"
import { MoreTableCell } from "@/molecules/MoreTableCell"
import { DigestImageCell } from "../../molecules/DigestImageCell"
import { MoreTableCellDrawer } from "../../molecules/MoreTableCellDrawer"
import { ViewSbomCell } from "../../molecules/ViewSbomCell"

import type { SortOrder } from "@/atoms"
import type { RowClick } from "@/hooks/useLinkDrawerTooltip"
import type { ORDER_BY_PROPS } from "@/hooks/useOrderBy"
import type { TFunction } from "@/hooks/useTranslation"

export const getColumnsTablePreviewMode = (
  sorter: Omit<ORDER_BY_PROPS, "onSorterChange">
) => [
  {
    title: "Image Name",
    render: MoreTableCell,
    ...getDefaultColumnParams("imageName", sorter),
    sortDirections: ["descend", "ascend", "descend"] as SortOrder[]
  },
  {
    title: "Digest",
    width: 130,
    render: DigestImageCell,
    ...getDefaultColumnParams("digestShort")
  }
]

export const getColumnsTable = ({
  sorter,
  t,
  convertors,
  previewMode,
  onRowClick
}: {
  sorter: Omit<ORDER_BY_PROPS, "onSorterChange">
  t: TFunction
  convertors: NumberConvertor
  onRowClick: RowClick
  previewMode?: boolean
}) => {
  const columnsPreviewMode = getColumnsTablePreviewMode(sorter)

  if (previewMode) return columnsPreviewMode

  return [
    ...columnsPreviewMode,
    CELLS.getIssuesSummaryCell({ t, convertors, sorter }),
    {
      title: "Apps",
      width: 70,
      className: "center-align-tab-template-component",
      sortDirections: ["descend", "ascend"] as SortOrder[],
      render: ImpactCell({ onRowClick }),
      ...getDefaultColumnParams("applicationsCount", sorter)
    },
    {
      title: "Derived Images",
      width: 150,
      render: MoreTableCellDrawer(onRowClick),
      ...getDefaultColumnParams("relatedImage")
    },
    {
      title: "SBOM",
      width: 60,
      className: "center-align-tab-template-component",
      render: ViewSbomCell,
      ...getDefaultColumnParams("sbomQuery")
    },
    CELLS.getLastDetectedCell({
      entityName: "base image",
      t,
      width: 155,
      ...getDefaultColumnParams("lastDetectionData")
    })
  ]
}
